/** Yeni modül menü yolları — yetki filtresi. */

export function isYeniMenuPathAllowed(path, can) {
    if (!path?.startsWith("/yeni/")) return true;
    if (path.startsWith("/e/hesap")) return can("kasa-hesaplar", "read");
    if (path.includes("odeme-rapor")) return can("odeme-raporlari", "read");
    if (path.includes("yetki")) return can("yetki-sablonlari", "read");
    if (path.includes("zaman-asimi")) return can("sigorta-dosyalari", "read");
    if (path.includes("muvekkil-merkezi")) return can("muvekkil-merkezi", "read");
    if (path.includes("muvekkil-panel-ayar")) return can("muvekkil-merkezi", "read");
    if (path.includes("supreme-ops")) return can("sigorta-dosyalari", "read");
    if (path.includes("rayic-istihbarat")) return can("sigorta-dosyalari", "read");
    if (path.includes("partsouq-oem")) return can("sigorta-dosyalari", "read");
    if (path.includes("bilus-parca")) return can("sigorta-dosyalari", "read");
    if (path.includes("ekspertiz-hasar")) return can("sigorta-dosyalari", "read");
    if (path.includes("deger-kaybi-gelismis")) return can("sigorta-dosyalari", "read");
    if (path.includes("deger-kaybi-on-hesap")) return can("sigorta-dosyalari", "read");
    if (path.includes("kusur-sorgulama")) return can("sigorta-dosyalari", "read");
    if (path.includes("yatar-bedeli")) return can("sigorta-dosyalari", "read");
    if (path.includes("tahkim-merkezi")) return can("tahkim-dosyalari", "read");
    if (path.includes("icra-merkezi")) return can("icralar", "read");
    if (path.includes("site-yonetimi")) return true;
    if (path.includes("sistem-gunlugu")) return true;
    if (path.includes("dosya-yorum")) return can("dosya-yorumlari", "read");
    return true;
}
